module.exports = "/cyber/_next/static/images/hitSteam-1e6c641a732b983f49f70688eb0c49af.jpg";